import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { InteriorSlide, SlideTitle } from './SlideShell';
import type { SlideProps } from './SlideShell';
import { executionSteps, executionSupport } from '../../data/snakkerStory';
export function SlideExecution({}: SlideProps) {
  return <InteriorSlide data-id="element-398" data-mp="1yo7c14y25rcq">
      <SlideTitle eyebrow="From asset to execution" data-id="element-399" data-mp="1ynp7ll18s6tq">
        We can build the Snak. <span className="text-[var(--brand)]" data-id="element-400" data-mp="2cngobtj581bf">Or help run the campaign around it.</span>
      </SlideTitle>

      <div className="flex min-h-0 flex-1 flex-col justify-center" data-id="element-401" data-mp="27p5f9l0o9uu9">
        <ol className="flex items-stretch" aria-label="Operating model" data-id="element-402" data-mp="2meulvvrjar1x">
          {executionSteps.map((step, i) => <React.Fragment key={step} data-id="element-403" data-mp="2hgt0h46myfna" data-mpi={i}>
              <motion.li initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.15 + i * 0.08,
            duration: 0.4
          }} className={`flex min-w-0 flex-1 flex-col border-t-2 pt-[clamp(0.75rem,1.4vw,1.2rem)] ${i === 1 ? 'border-[var(--brand)]' : 'border-[var(--fg)]'}`} data-id="element-404" data-mp="2hhug7lyljqbc">
                <span className="font-mono text-[clamp(0.58rem,0.75vw,0.7rem)] tracking-[0.2em] text-[var(--muted)]" data-id="element-405" data-mp="2wyg6yd7baeqn">0{i + 1}</span>
                <span className={`mt-1 truncate text-[clamp(1.1rem,2.2vw,2.1rem)] font-extrabold tracking-[-0.04em] ${i === 1 ? 'text-[var(--brand)]' : 'text-[var(--fg)]'}`} data-id="element-406" data-mp="31yko85g1ndhx">
                  {step}
                </span>
              </motion.li>
              {i < executionSteps.length - 1 && <li aria-hidden="true" className="flex w-[clamp(1rem,2vw,2rem)] flex-shrink-0 items-start justify-center pt-[clamp(1.6rem,2.6vw,2.4rem)]" data-id="element-407" data-mp="3knra21c4wl7y">
                  <ChevronRightIcon className="h-4 w-4 text-[var(--brand-light)]" data-id="element-408" data-mp="3poyje4txdsgq" />
                </li>}
            </React.Fragment>)}
        </ol>

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.7,
        duration: 0.5
      }} className="mt-[clamp(2rem,4.5vw,4rem)] flex flex-wrap items-center gap-x-[clamp(1rem,2vw,1.75rem)] gap-y-3 rounded-2xl bg-[var(--surface)] px-[clamp(1.25rem,2.4vw,2.25rem)] py-[clamp(1rem,2vw,1.6rem)]" data-id="element-409" data-mp="1ul0hamdq5qdd">
          <p className="text-[clamp(0.62rem,0.82vw,0.76rem)] font-bold uppercase tracking-[0.2em] text-[var(--brand)]" data-id="element-410" data-mp="2d9xaso1aseuj">Snakker can support</p>
          <ul className="flex flex-wrap gap-1.5" data-id="element-411" data-mp="28aua1fscousd">
            {executionSupport.map(s => <li key={s} className="rounded-full bg-white px-3.5 py-1.5 text-[clamp(0.76rem,1vw,0.95rem)] font-semibold text-[var(--fg)] ring-1 ring-[var(--fg)]/[0.06]" data-id="element-412" data-mp="2malhsys9xexx">
                {s}
              </li>)}
          </ul>
        </motion.div>
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.9,
        duration: 0.5
      }} className="mt-[clamp(0.75rem,1.4vw,1.2rem)] text-[clamp(0.85rem,1.15vw,1.08rem)] font-medium text-[var(--muted)]" data-id="element-413" data-mp="nxbpla5liw2t">
          Pick the parts you need — from a single Snak to the full cycle.
        </motion.p>
      </div>
    </InteriorSlide>;
}